import { render, staticRenderFns } from "./rank.vue?vue&type=template&id=3f83d8c8&scoped=true&"
import script from "./rank.vue?vue&type=script&lang=js&"
export * from "./rank.vue?vue&type=script&lang=js&"
import style0 from "./rank.vue?vue&type=style&index=0&id=3f83d8c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f83d8c8",
  null
  
)

export default component.exports